import { render, staticRenderFns } from "./DuplicateReportModal.vue?vue&type=template&id=68473f52&scoped=true"
import script from "./DuplicateReportModal.vue?vue&type=script&lang=js"
export * from "./DuplicateReportModal.vue?vue&type=script&lang=js"
import style0 from "./DuplicateReportModal.vue?vue&type=style&index=0&id=68473f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68473f52",
  null
  
)

export default component.exports